export const TASK_GROUP_SIZE_OPTIONS = [10, 20, 30, 40, 50] as const;

export const DEFAULT_TASK_GROUP_SIZE = TASK_GROUP_SIZE_OPTIONS[0];
